import { Injectable } from '@angular/core'
import { Paginator } from '../../../shared/interfaces/paginator.interface'
import { CatalogueService } from '../../../shared/services/catalogue.service'
import { CatalogueResourceSlug } from '../enums/catalogue-resource-slug.enum'
import { Tool } from '../interfaces/tool.interface'
import { ToolDto } from '../resources/tool/dtos/tool.dto'

@Injectable({
  providedIn: 'root'
})
export class ToolService {
  constructor(private catalogueService: CatalogueService) {}

  list(listParams: {
    page?: number | string
    orderBy?: string
    orderByDesc?: string
    toolIds?: number[]
    toolTypeIds?: number[]
    countryIds?: number[]
    lifecycleIds?: number[]
    policyAreaIds?: number[]
    impactedStakeholderIds?: number[]
    stakeholderGroupIds?: number[]
    purposeIds?: number[]
    targetSectorIds?: number[]
    targetUserIds?: number[]
    targetGroupIds?: number[]
    licensingRegimeIds?: number[]
    maturityIds?: number[]
    validityIds?: number[]
    enforcementIds?: number[]
    benefitIds?: number[]
    geographicalScopeIds?: number[]
    peopleInvolvedIds?: number[]
    requiredSkillIds?: number[]
    technologyPlatformIds?: number[]
    organisationIds?: number[]
    objectiveIds?: number[]
    programmingLanguageIds?: number[]
    approachIds?: number[]
    withoutPagination?: boolean
    terms?: string
    slug?: string
    toXLS?: string
  }): Promise<Paginator<Tool> | Tool[]> {
    const params = Object.assign({}, listParams)

    if (params.withoutPagination) {
      params.withoutPagination = true
    }

    if (params.orderBy) {
      if (params.orderBy === 'dateAsc') {
        params.orderBy = 'publishedAt'
      }
      if (params.orderBy === 'dateDesc') {
        params.orderBy = 'publishedAt'
        params.orderByDesc = 'true'
      }
      if (params.orderBy === 'nameAsc') {
        params.orderBy = 'name'
      }
      if (params.orderBy === 'nameDesc') {
        params.orderBy = 'name'
        params.orderByDesc = 'true'
      }
    }

    if (params.withoutPagination) {
      return this.catalogueService.list(
        CatalogueResourceSlug.Tools,
        params
      ) as Promise<Tool[]>
    } else {
      return this.catalogueService.list(
        CatalogueResourceSlug.Tools,
        params
      ) as Promise<Paginator<Tool>>
    }
  }

  listPaginated(listParams: { [key: string]: any }): Promise<Paginator<Tool>> {
    listParams.withoutPagination = false
    return this.list(listParams) as Promise<Paginator<Tool>>
  }

  listUnpaginated(listParams: { [key: string]: any }): Promise<Tool[]> {
    listParams.withoutPagination = true

    return this.list(listParams) as Promise<Tool[]>
  }

  show(slug: string): Promise<Tool> {
    return this.catalogueService.showBySlug(
      CatalogueResourceSlug.Tools,
      slug
    ) as Promise<Tool>
  }

  store(toolDto: ToolDto): Promise<Tool> {
    return this.catalogueService.store(CatalogueResourceSlug.Tools, toolDto)
  }
}
